import { gql } from "@apollo/client";

export const GET_PROVIDER_UTILIZATION_CHART = gql(`
  query GetKPIProviderUtilization($input: KPIQueryInputArgs!)
  @permission(requires: viewKPIs)
  {
    kpiProviderUtilization(input: $input) {
      shiftTime
      visitTime
      interVisitDriveTime
      startEndDriveTime
      calendarBlockTime
    }
  }
`);

export const GET_KPI_VISIT_TYPES_QUERY = gql(`
  query GetKPIVisitTypes($input: KPIQueryInputArgs!)
  @permission(requires: viewKPIs)
  {
    kpiVisitTypes(input: $input) {
      visitTypePercentages
      totalVisits
      visitVolumeByDate {
        date
        category
        count
      }
    }
  }
`);

export const GET_CANCELATION_RATE_CHART_QUERY = gql(`
  query KPIChartCancellationRate ($input: KPIQueryInputArgs!)
  @permission(requires: viewKPIs) {
    kpiCancellationRate(input: $input) {
      cancellationRates
      totalCancellationRate
    }
  }
`);

export const GET_KPI_SUMARY_QUERY = gql(`
  query KPISummary ($input: KPIQueryInputArgs!)
  @permission(requires: viewKPIs) {
    kpiSummary(input: $input) {
      totalVisits
      rankCategoryCounts {
        high
        medium
        low
      }
      visitsByStatus {
        canceled
        complete
        in_progress
        arrived
        en_route
        scheduled
      }
    }
  }
`);

export const GET_KPI_VISITS_PER_8H_SHIFT = gql(`
  query GetKPIVisitPerShift($input: KPIQueryInputArgs!)
  @permission(requires: viewKPIs)
  {
    kpiVisitsPerShift(input: $input) {
      visitsPerShift {
        date
        totalVisits
        totalShiftHours
        visitsPerShift
      }
    }
  }
`);
